// TODO: Fix this the next time the file is edited.
// eslint-disable-next-line import/order
import React from 'react';
import { Glyphicon } from 'react-bootstrap';

export default class CheatCheetElement extends React.Component {
  deleteCheatsheet = event => {
    event.stopPropagation();
    // TODO: Fix this the next time the file is edited.
    // @ts-ignore
    // eslint-disable-next-line react/prop-types
    const { actions } = this.props;
    // TODO: Fix this the next time the file is edited.
    // eslint-disable-next-line react/prop-types
    actions.deleteCheatsheet(
      event.currentTarget.getAttribute('data-name'),
      'cheatsheet'
    );
  };

  updateCheatsheet = event => {
    event.stopPropagation();
    // TODO: Fix this the next time the file is edited.
    // @ts-ignore
    // eslint-disable-next-line react/prop-types
    const { actions } = this.props;
    // TODO: Fix this the next time the file is edited.
    // eslint-disable-next-line react/prop-types
    actions.updateCheatsheet(
      event.currentTarget.getAttribute('data-name'),
      'cheatsheet'
    );
  };

  formatstr = str => {
    const st = str.split('\n');
    return st.length > 1 ? `${st[0]}...` : st[0];
  };

  render() {
    // TODO: Fix this the next time the file is edited.
    // @ts-ignore
    // eslint-disable-next-line react/prop-types
    const { value, ind, pr } = this.props;
    return (
      // TODO: Fix this the next time the file is edited.
      // eslint-disable-next-line react/prop-types
      <tr key={value.title} data-name={ind} className='listrow moveable'>
        <td style={{ verticalAlign: 'middle', padding: '0' }}>
          <Glyphicon glyph='option-vertical' />
        </td>
        <td style={{ width: '10%', minWidth: '60px' }}>
          <img
            src={
              // TODO: Fix this the next time the file is edited.
              // eslint-disable-next-line react/prop-types
              value.picture.isNew // TODO: Fix this the next time the file is edited.
                ? // eslint-disable-next-line react/prop-types
                  value.picture.data // TODO: Fix this the next time the file is edited.
                : // eslint-disable-next-line react/prop-types
                  `${value.picture.data}?p=${pr}`
            }
            style={{ width: '48px', height: '48px' }}
            alt='...'
            className='img-thumbnail'
          />
        </td>
        {/* TODO: Fix this the next time the file is edited. */}
        {/* eslint-disable-next-line react/prop-types */}
        <td style={{ maxWidth: '90px' }} title={value.title}>
          {/* TODO: Fix this the next time the file is edited. */}
          {/* eslint-disable-next-line react/prop-types */}
          <span className='big-text-field'>{value.title}</span>
        </td>
        <td
          style={{ maxWidth: '90px' }}
          className='cheatcheet-subtitle'
          // TODO: Fix this the next time the file is edited.
          // eslint-disable-next-line react/prop-types
          title={value.subtitle}
        >
          <span className='big-text-field'>
            {/* TODO: Fix this the next time the file is edited. */}
            {/* eslint-disable-next-line react/prop-types */}
            {this.formatstr(value.subtitle)}
          </span>
        </td>
        <td
          style={{
            width: '15%',
            textAlign: 'center',
            verticalAlign: 'middle',
            cursor: 'pointer',
            minWidth: '55px',
          }}
        >
          <i
            className='fas fa-pen'
            data-name={ind}
            onClick={this.updateCheatsheet}
            style={{ marginRight: '10px' }}
          />
          <i
            className='fas fa-times'
            data-name={ind}
            onClick={this.deleteCheatsheet}
          />
        </td>
      </tr>
    );
  }
}
